module.exports = "https://static.wanderu.com/static/media/flight.76fbfb91.svg";